import { FaIcon } from '@/lib/fa'
import { faExclamation } from '@fortawesome/free-solid-svg-icons'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
    error: unknown
}

// Typed backend errors (SupertachoResult.On400Error) carry a code we can turn
// into a real message instead of dumping "AxiosError: Request failed...".
const ERROR_CODE_TRANSLATIONS: Record<string, string> = {
    TIMESHEET_CONFIGURATION_ERROR: 'timesheet.settlement-first-day-error',
}

const getErrorCode = (error: unknown): string | undefined =>
    (error as any)?.response?.data?.code ?? (error as any)?.response?.data?.Code

export const PayrollErrorScreen = ({ error } : Props) => {
    const { t } = useLocalize()
    const translationKey = ERROR_CODE_TRANSLATIONS[getErrorCode(error) ?? '']
    return (
        <div className='tw-p-10 tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4'>
            <FaIcon icon={faExclamation} className='tw-w-10 tw-h-10' /> 
            <div className='tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-max-w-md tw-text-center'>
                <h3 className='tw-mb-1 tw-text-lg'>{t('common.error')}</h3>
                <p className='tw-text-sm tw-mb-0 tw-text-content-base'>{translationKey ? t(translationKey) : String(error)}</p>
            </div>
        </div>
    )
}
